import React from 'react';
import { motion } from 'framer-motion';
import { Popup } from '../hooks/usePopup';

interface PopupMessageProps {
    popup: Popup | null;
    popupVisible: boolean;
    popupTransitionDuration: number;
    onAnimationComplete: () => void;
    className?: string;
}

const PopupMessage: React.FC<PopupMessageProps> = ({
    popup,
    popupVisible,
    popupTransitionDuration,
    onAnimationComplete,
    className = '',
}) => {
    if (!popup) return null;

    return (
        <div className={`absolute bottom-0 w-full ml-6 translate-y-full z-50 ${className}`}>
            <motion.div
                key={popup.id}
                initial={{ opacity: 0 }}
                animate={{ opacity: popupVisible ? 1 : 0 }}
                transition={{ duration: popupTransitionDuration }}
                onAnimationComplete={() => {
                    if (!popupVisible) onAnimationComplete();
                }}
            >
                <div
                    className={`text-xl text-shadow-border ${popup.type === 'success'
                        ? 'shadow-green-800'
                        : 'shadow-red-800'
                        }`}
                >
                    {popup.message}
                </div>
            </motion.div>
        </div>
    );
};

export default PopupMessage;
